var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M15.813 4.147c.53-.53 1.386-.53 1.915 0 .488.488.526 1.256.113 1.787l-.113.128-9.31 9.31c-.488.488-1.256.525-1.787.112l-.128-.112-4.231-4.232c-.53-.529-.53-1.386 0-1.915.488-.488 1.256-.526 1.787-.113l.128.113 3.274 3.273 8.352-8.351z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue-tick.a00388ab9da24d301e7473ebcdc27c60.svg";
export { ForwardRef as ReactComponent };